export default "__VITE_ASSET__Dw0P7dwB__"